import React, { useCallback } from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Form, SonForm, SubmitButton, TextParam, useForm } from '../../../../_lib/Form2';
import { useDelayed } from '../../../../hooks/useDelayed';
import { useRefreshBlock } from '../../../../_lib/BlockFetcher';
import { useModalContext } from '../../../../components/organisms/ModalDialog/ModalContext';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';
import { Hint } from '../../../../_lib/components/Hint';

export type SendEmailFormTypes = TextParam<'emailAddress'>;

type SendEmailFormProps = {
  form: SonForm<SendEmailFormTypes>;
  mandateContactPersonEmail: string;
};

export function SendEmailForm({ form, mandateContactPersonEmail }: SendEmailFormProps) {
  const { t } = useSonTranslation('AccessLevel');
  const id = useHtmlValidId();

  const { refresh } = useRefreshBlock();
  const { closeModal } = useModalContext();
  const refreshAndClose = useCallback(() => {
    refresh();
    closeModal();
  }, [closeModal, refresh]);
  const delayedRefreshAndClose = useDelayed(refreshAndClose);
  const onSuccess = () => {
    delayedRefreshAndClose();
  };

  const { formProps, fetchState } = useForm({ form, onSuccess });

  return (
    <Form {...formProps} id={`access-level-email-request-form-${id}`}>
      <Hint message={t('checkEmail.hint', { email: mandateContactPersonEmail })} />
      <SubmitButton
        buttonLabel={t('checkEmail.submit')}
        messageSuccess={t('checkEmail.status.success')}
        messageSending={t('checkEmail.status.sending')}
        messageFail={t('checkEmail.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
